import { useMemo, useState } from "react";
import { AdminShell } from "@project/admin/components/admin-shell";
import { Input } from "@project/components/ui/input";
import { Badge } from "@project/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@project/components/ui/table";
import { Search } from "lucide-react";
import { mockAnimals } from "@project/lib/mock-modules";

export default function AnimalDirectory() {
  const [q, setQ] = useState("");
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) {
      return mockAnimals;
    }
    return mockAnimals.filter(a =>
      [a.id, a.name, a.breed, a.species].some(v => v.toLowerCase().includes(s))
    );
  }, [q]);

  return (
    <AdminShell
      title="Animal Directory"
      subtitle="All animals registered in the gaushala"
    >
      <div className="mb-4 flex items-center gap-2">
        <div className="relative max-w-sm flex-1">
          <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Search by name, breed, ID…"
            className="pl-8"
          />
        </div>
        <div className="text-xs text-muted-foreground">
          {filtered.length} of {mockAnimals.length}
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card shadow-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Species</TableHead>
              <TableHead>Breed</TableHead>
              <TableHead>Age</TableHead>
              <TableHead>Health</TableHead>
              <TableHead>Vaccinated</TableHead>
              <TableHead className="text-right">Milk / day</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map(a => (
              <TableRow key={a.id}>
                <TableCell className="font-mono text-xs">{a.id}</TableCell>
                <TableCell className="font-medium">{a.name}</TableCell>
                <TableCell>{a.species}</TableCell>
                <TableCell>{a.breed}</TableCell>
                <TableCell>{a.age}</TableCell>
                <TableCell>
                  <Badge
                    className={
                      a.health === "Healthy"
                        ? "bg-emerald-500/15 text-emerald-700 hover:bg-emerald-500/15"
                        : a.health === "Under Care"
                          ? "bg-amber-500/15 text-amber-700 hover:bg-amber-500/15"
                          : "bg-rose-500/15 text-rose-700 hover:bg-rose-500/15"
                    }
                  >
                    {a.health}
                  </Badge>
                </TableCell>
                <TableCell>
                  {a.vaccinated ? (
                    <Badge variant="secondary">Yes · {a.lastVaccine}</Badge>
                  ) : (
                    <Badge variant="outline">Pending</Badge>
                  )}
                </TableCell>
                <TableCell className="text-right">
                  {a.dailyMilkLitres > 0 ? `${a.dailyMilkLitres} L` : "—"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </AdminShell>
  );
}
